import { Box, Grid } from '@mui/material';
import theme from 'theme';
import TeamVacationRequestsTable from './TeamVacationRequestsTable';

const TeamVacationRequestsView = () => (
  <Box sx={{ padding: theme.spacing(4) }}>
    <Grid container spacing={4}>
      <Grid
        size={{
          lg: 12,
          md: 12,
          xl: 12,
          xs: 12,
        }}
      >
        <TeamVacationRequestsTable />
      </Grid>
    </Grid>
  </Box>
);

export default TeamVacationRequestsView;
